// extracted by mini-css-extract-plugin
export default {"startContainer":"start_startContainer__81zXs","btnContainer":"start_btnContainer__UCV+t"};